import { connect } from 'react-redux';
import { channelLayoutValues } from 'widget/player-widget';

import { getChannelLayout } from 'shared/selectors/app-settings';

import ClassicView from 'widget/views/desktop/classic/classic';
import StripView from 'widget/views/desktop/strip/strip';
import CompactView from 'widget/views/desktop/compact/compact';

const VIEWS_BY_LAYOUT_TYPES = {
  [channelLayoutValues.STRIP]: StripView,
  [channelLayoutValues.CLASSIC]: ClassicView,
  [channelLayoutValues.COMPACT]: CompactView,
};

@connect(state => ({
  layout: getChannelLayout(state),
}))
export default class DesktopViewsSwitcher extends React.Component {

  static propTypes = {
    layout: React.PropTypes.number,
    channelData: React.PropTypes.object,
  };

  render() {
    const { layout } = this.props;

    if (!layout) {
      return null;
    }

    // TODO: remove if don`t needed
    if (_.isEmpty(this.props.channelData)) {
      return null;
    }

    const View = VIEWS_BY_LAYOUT_TYPES[layout] || ClassicView;
    return <View {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/desktop-views-switcher.js